import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const includes = ['The Main Happy Lunchbox Guide (+200 Recipes)', 'Weekly Meal Plans & 15-minute recipes', '+ 5 Exclusive Bonuses (worth $195)'];
  return <section id="pricing" className="bg-gray-50 py-16 px-4" data-id="element-115">
      <div className="max-w-3xl mx-auto" data-id="element-116">
        <div className="text-center mb-10" data-id="element-117">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1f2e10] uppercase" data-id="element-118">
            Invest In Your Child's Future
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} id="offer" className="bg-[#1f2e10] rounded-3xl overflow-hidden shadow-2xl border-4 border-[#c4f000] scroll-mt-4" data-id="element-119">
          <div className="bg-[#c4f000] text-[#1f2e10] text-center py-2 font-bold text-sm uppercase tracking-widest" data-id="element-120">
            Special Limited Time Offer
          </div>

          <div className="p-5 md:p-8 text-center" data-id="element-121">
            <h3 className="text-xl md:text-2xl font-black text-white mb-3 md:mb-4" data-id="element-122">
              Happy Lunchbox System + 5 Bonuses
            </h3>

            <div className="bg-white/5 rounded-2xl p-4 md:p-5 mb-4 md:mb-5 text-left border border-white/10" data-id="element-123">
              <p className="text-white font-bold mb-2 md:mb-3 border-b border-white/10 pb-2 text-sm" data-id="element-124">
                Summary of everything you get today:
              </p>
              <ul className="space-y-1.5" data-id="element-125">
                {includes.map((item, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-126">
                    <Check size={16} className="text-[#c4f000] mt-0.5 flex-shrink-0" data-id="element-127" />
                    <span className="text-gray-300 text-xs" data-id="element-128">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mb-4 md:mb-5" data-id="element-129">
              <p className="text-gray-400 line-through text-sm md:text-base mb-1" data-id="element-130">
                Total Value: $195.00 USD
              </p>
              <span className="text-white text-base md:text-lg block mb-1" data-id="element-131">
                Get it all TODAY for only:
              </span>
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-132">
                <span className="text-4xl md:text-5xl font-black text-[#c4f000]" data-id="element-133">
                  $27.00
                </span>
                <span className="text-[#c4f000] text-lg font-bold" data-id="element-134">USD</span>
              </div>
              <p className="text-red-400 font-bold text-xs animate-pulse" data-id="element-135">
                ⚠️ OFFER EXPIRES SOON
              </p>
            </div>

            <CTAButton href="https://happy-lunchbox.impultienda.ar/checkout" className="w-full text-base md:text-lg py-4 mb-3" data-id="element-136">
              YES! I WANT THE HAPPY LUNCHBOX SYSTEM NOW!
            </CTAButton>

            <p className="text-gray-400 text-xs" data-id="element-137">
              Instant Lifetime Access. 100% Secure Payment.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}